import { Component, isDevMode } from '@angular/core';
import { UtilityService } from '../../../shared/services/utility.service';
import { CoreService } from '../../services/core.service';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../../shared/services/authentication.service';


@Component({
    selector: 'my-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})
export class LoginComponent {
    name;
    username: string;
    password: string;
    rememberMe: boolean;
    error: string;
    loading: boolean;

    constructor(
        private auth: AuthenticationService,
        private util: UtilityService,
        private api: CoreService,
        private router: Router
    ) {

        this.util.setTitle('Login');

        if (isDevMode()) {
            this.name = 'tx_super_admin';
            this.password = 'OiWKhnJci7nMv0l';
        }
    }

    login(): void {
        this.error = '';

        this.api.login({
            name: this.name,
            password: this.password,
            rememberMe: this.rememberMe
        }).subscribe((data: any) => {
            this.auth.saveLogin(data);
            this.router.navigate(['/']);
        }, err => {
            this.error = err.error.message || err.error;
        });
    }
}
